export const APP_NAME = "Kids Money";

export const LOGO_URL = "/art/logo.png";
